export function isElementInViewport(el: Element, visibleElementPart = 1) {
    const bounding = el.getBoundingClientRect();

    return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.right * visibleElementPart <=
            (window.innerWidth || document.documentElement.clientWidth) &&
        bounding.bottom * visibleElementPart <=
            (window.innerHeight || document.documentElement.clientHeight)
    );
}
